module.exports = __webpack_public_path__ + "static/stateSign.e7a8f00b.png";